export default "__VITE_ASSET__CIszksQ4__"